import React, { useEffect, useState } from 'react';
import styled from 'styled-components'
import '@styles/header.css';

import Slide from 'react-reveal/Slide';

const HeaderWrapper = styled.div`
  position: relative;
  font-size: 0;
  margin-top: calc(var(--initial-vh, 1svh) * 5);
  @media screen and (orientation:portrait) {
    direction: rtl;
    margin-top: calc(var(--initial-vh, 1svh) * 5);
    padding: 0 calc(var(--initial-vh, 1svh) * 5) 0 calc(var(--initial-vh, 1svh) * 5);
    border-top: 1px solid var(--text);
  }
`

const VerticalLine = styled.div`
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background: var(--text);
  transform: scaleY(0);
  transition: transform 0.75s ease-in-out;
  backface-visibility: hidden;
  will-change: transform;

  &.animate-header {
    transform: scaleY(1) !important;
  }

  &.left {
    transform-origin: top;
  }

  &.right {
    transform-origin: bottom;
  }

  @media screen and (orientation:portrait) {
      display: block;
  }
`

const GridOverlay = styled.div`
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: calc(var(--initial-vh, 1svh) * 5);
  right: calc(var(--initial-vh, 1svh) * 5);
  pointer-events: none;
  direction: ltr;

  @media screen and (orientation:portrait) {
    display: block;
  }
`

const LeftLine = styled.div`
  overflow: hidden;
  position: absolute;
  margin: 0;
  padding: 0;
  color: var(--text);
  box-sizing: border-box;
  width: 1px;
  @media screen and (orientation:portrait) {
    display: none;
  };
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: transform 0.75s ease-in-out;
    @media screen and (orientation:portrait) {
      display: none;
    }
  }
`

const HeaderText = styled.h1`
  overflow: hidden;
  position: relative;
  margin: 0;
  padding: 0;
  font-size: calc(var(--initial-vh, 1svh) * 21);
  line-height: calc(var(--initial-vh, 1svh) * 22.5);
  height: calc(var(--initial-vh, 1svh) * 22.5);
  font-family: 'manrope-semibold', sans-serif;
  text-transform: uppercase;
  color: var(--text);
  box-sizing: border-box;
  @media screen and (orientation:portrait) {
    padding: 1.25rem 0;
    display: inline-block;
    width: 25%;
    vertical-align: top;
    writing-mode: vertical-rl;
    height: calc(var(--initial-vh, 1svh) * 90);
    direction: ltr;
    font-size: 17.5vw;
    line-height: 24vw;
  };
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-top: 1px solid var(--text);
    transform: scaleX(0);
    transition: transform 0.75s ease-in-out;
    @media screen and (orientation:portrait) {
      display: none;
    }
  }
`

const Header = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [playAnimation, setPlayAnimation] = useState(false);
  const [isPortrait, setIsPortrait] = useState(false);

  useEffect(() => {
    let lastWidth = window.innerWidth;

    const setVh = () => {
      const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      document.documentElement.style.setProperty('--initial-vh', `${height * 0.01}px`);
    };

    const handleResize = () => {
      if (window.innerWidth !== lastWidth) {
        lastWidth = window.innerWidth;
        setVh();
      }
      const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      setIsPortrait(height >= width);
    };

    const onPageLoad = () => {
      setPlayAnimation(true);
      setVh();
      const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      setIsPortrait(height >= width);
      setIsLoading(false);
    };

    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad);
    }
    
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('load', onPageLoad);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      {isLoading ? (
        <HeaderWrapper>
          <HeaderText />
          <HeaderText />
          <HeaderText />
          <HeaderText />
          <LeftLine />
          <GridOverlay>
            <VerticalLine style={{ left: 0 }} className="left" />
            <VerticalLine style={{ left: '25%' }} className="right" />
            <VerticalLine style={{ left: '50%' }} className="left" />
            <VerticalLine style={{ left: '75%' }} className="right" />
            <VerticalLine style={{ left: '100%' }} className="left" />
          </GridOverlay>
        </HeaderWrapper >
      ) : (
        <HeaderWrapper className={playAnimation ? 'animate-header left' : 'left'}>
          <HeaderText className={playAnimation ? 'animate-header left' : 'left'} style={{ color: 'var(--accent)' }}>
            <Slide left={isPortrait} bottom={!isPortrait} cascade delay={100}>
              Raunaq
            </Slide>
          </HeaderText >
          <HeaderText className={playAnimation ? 'animate-header right' : 'right'} style={{ color: 'var(--accent)' }}>
            <Slide left={isPortrait} bottom={!isPortrait} cascade delay={150}>
              Singh
            </Slide>
          </HeaderText >
          <HeaderText className={playAnimation ? 'animate-header left' : 'left'}>
            <Slide left={isPortrait} bottom={!isPortrait} cascade delay={200}>
              Creative
            </Slide>
          </HeaderText>
          <HeaderText className={playAnimation ? 'animate-header right' : 'right'}>
            <Slide left={isPortrait} bottom={!isPortrait} cascade delay={250}>
              Dev.
            </Slide>
          </HeaderText>
          <LeftLine className={playAnimation ? 'animate-header left' : 'left'} />
          <GridOverlay>
            <VerticalLine style={{ left: 0 }} className={playAnimation ? 'animate-header left' : 'left'} />
            <VerticalLine style={{ left: '25%' }} className={playAnimation ? 'animate-header right' : 'right'} />
            <VerticalLine style={{ left: '50%' }} className={playAnimation ? 'animate-header left' : 'left'} />
            <VerticalLine style={{ left: '75%' }} className={playAnimation ? 'animate-header right' : 'right'} />
            <VerticalLine style={{ left: '100%' }} className={playAnimation ? 'animate-header left' : 'left'} />
          </GridOverlay>
        </HeaderWrapper >
      )}
    </>
  );
};

export default Header;